export type ClsxArgs = Array<Maybe<string | boolean | Array<Maybe<string | boolean>>>>;

/**
 * @deprecated - Should be deleted
 *
 * Use cn from 'classnames';
 * `import cn from 'classnames';`
 */
export const clsx = (...args: ClsxArgs): string =>
    args
        .reduce((classNames: string[], arg) => {
            if (typeof arg === 'string') {
                classNames.push(arg.trim());
            } else if (Array.isArray(arg)) {
                classNames.push(clsx(...arg));
            }

            return classNames;
        }, [])
        .join(' ');
